var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIa4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 242,
    viewBox: "0 0 292 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 242,
    rx: 19,
    fill: "url(#paint0_linear_483_186)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 54,
    width: 65,
    height: 98,
    rx: 19,
    fill: "url(#paint1_linear_483_186)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 95,
    width: 31,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 112,
    width: 31,
    height: 2,
    rx: 1,
    fill: "#F8F8F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 116,
    width: 31,
    height: 2,
    rx: 1,
    fill: "#F8F8F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 120,
    width: 31,
    height: 2,
    rx: 1,
    fill: "#F8F8F8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 124,
    width: 31,
    height: 2,
    rx: 1,
    fill: "#F8F8F8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 64,
    width: 27,
    height: 24,
    rx: 12,
    fill: "#F8F8F8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 137,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#F8F8F8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7412,
    y: 16,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 69,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 91,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 113,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 135,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 157,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 179,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 201,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 39,
    y: 69,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 39,
    y: 91,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 39,
    y: 113,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 39,
    y: 135,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 39,
    y: 157,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 39,
    y: 179,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 39,
    y: 201,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 67,
    y: 69,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 67,
    y: 91,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 67,
    y: 113,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 67,
    y: 135,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 67,
    y: 157,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 67,
    y: 179,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 67,
    y: 201,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 95,
    y: 69,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 95,
    y: 91,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 95,
    y: 113,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 95,
    y: 135,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 95,
    y: 157,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 95,
    y: 179,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.55,
    x: 95,
    y: 201,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "#F8F8F8"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 123,
    y: 69,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint2_linear_483_186)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 123,
    y: 91,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint3_linear_483_186)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 123,
    y: 113,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint4_linear_483_186)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 123,
    y: 135,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint5_linear_483_186)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 123,
    y: 157,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint6_linear_483_186)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 123,
    y: 179,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint7_linear_483_186)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 123,
    y: 201,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint8_linear_483_186)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 151,
    y: 69,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint9_linear_483_186)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 151,
    y: 91,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint10_linear_483_186)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 151,
    y: 113,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint11_linear_483_186)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 151,
    y: 135,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint12_linear_483_186)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 151,
    y: 157,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint13_linear_483_186)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 151,
    y: 179,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint14_linear_483_186)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 151,
    y: 201,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint15_linear_483_186)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 179,
    y: 69,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint16_linear_483_186)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 179,
    y: 91,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint17_linear_483_186)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 179,
    y: 113,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint18_linear_483_186)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 179,
    y: 135,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint19_linear_483_186)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 179,
    y: 157,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint20_linear_483_186)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 179,
    y: 179,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint21_linear_483_186)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 179,
    y: 201,
    width: 20,
    height: 9,
    rx: 4.5,
    fill: "url(#paint22_linear_483_186)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 34,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_483_186",
    x1: 57.5,
    y1: 0,
    x2: 57.5,
    y2: 242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_483_186",
    x1: 259.5,
    y1: 54,
    x2: 259.5,
    y2: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_483_186",
    x1: 133,
    y1: 69,
    x2: 133,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_483_186",
    x1: 133,
    y1: 91,
    x2: 133,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_483_186",
    x1: 133,
    y1: 113,
    x2: 133,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_483_186",
    x1: 133,
    y1: 135,
    x2: 133,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_483_186",
    x1: 133,
    y1: 157,
    x2: 133,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_483_186",
    x1: 133,
    y1: 179,
    x2: 133,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_483_186",
    x1: 133,
    y1: 201,
    x2: 133,
    y2: 210,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_483_186",
    x1: 161,
    y1: 69,
    x2: 161,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_483_186",
    x1: 161,
    y1: 91,
    x2: 161,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_483_186",
    x1: 161,
    y1: 113,
    x2: 161,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_483_186",
    x1: 161,
    y1: 135,
    x2: 161,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_483_186",
    x1: 161,
    y1: 157,
    x2: 161,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_483_186",
    x1: 161,
    y1: 179,
    x2: 161,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_483_186",
    x1: 161,
    y1: 201,
    x2: 161,
    y2: 210,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_483_186",
    x1: 189,
    y1: 69,
    x2: 189,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_483_186",
    x1: 189,
    y1: 91,
    x2: 189,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_483_186",
    x1: 189,
    y1: 113,
    x2: 189,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_483_186",
    x1: 189,
    y1: 135,
    x2: 189,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_483_186",
    x1: 189,
    y1: 157,
    x2: 189,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_483_186",
    x1: 189,
    y1: 179,
    x2: 189,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_483_186",
    x1: 189,
    y1: 201,
    x2: 189,
    y2: 210,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIa4);
export default __webpack_public_path__ + "static/media/product-ia-4.1aecbc396db32a9dbeaf23587211162e.svg";
export { ForwardRef as ReactComponent };